<!--
 * @Author: Merlin
 * @Date: 2024-01-12 18:53:09
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-26 14:36:07
 * @Description: 往局开奖结果列表
-->

<template>
    <div
        class="history-list flex shadow relative justify-end history-results"
    >
        <!-- 近期废弃的类名： absolute -->
        <ul class="inset-0 gap-2 overflow-hidden inline-flex justify-end mt-4"
            v-if="aHistoryToShow.length > 0"
        >
            <li
                v-for="(oHistory, idx) of aHistoryToShow"
                :key="idx"
                class="min-w-[40px] h-[34px] flex items-center text-xs rounded-lg font-semibold justify-center leading-22"
                :class="[oHistory.sType]"
            >
                {{ oHistory.sVal }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';

const userStore = useUserStore();
const gameHistoryStore = useGameHistoryStore();

const aHistoryToShow = computed(() => {
    if (!userStore.isLoggedIn) return [];
    let { response = [] } = gameHistoryStore.gameHistoryDelay || {};
    response = response.slice(0, 15).reverse(); 
    const aResult = response.map((cur) => {
        const gameValue = (cur.randomSeed || '').replace(/_.+/g, '');
        const oThisOne = {
            iVal: gameValue,
            sVal: gameValue,
            sType: (() => {
                if (cur.winAmount > 0) return 'bg-[#161f2c] text-[#2283f6]';
                else return 'bg-[#161f2c] text-[#fa305c]';
            })(),
        };
        return oThisOne;
    });
    return aResult;
});

</script>


<style lang="scss" scoped>
.history-list{
    width: 100%; 
    overflow: hidden; 
    margin-bottom: 15px; 
    ul{
        width: 0; 
        flex: 1 1 100%;
    }
}

.history-results {
    &::after {
        background: linear-gradient(90deg, #15161f, #15161f00);
        bottom: 0;
        content: '';
        display: block;
        left: 0;
        position: absolute;
        top: 0;
        width: 30px;
    }
}

</style>